import { useState } from 'react'

// Senha Master (09/09): segunda senha, separada do login, exigida em toda exclusao de Proposta/
// Apolice, Sinistro, Assistencia, Financeiro e Cliente. Configurada pelo admin em Cadastro >
// Corretora. Este modal e generico: quem usa passa o titulo/mensagem e uma funcao onConfirmar(senha)
// que faz a chamada de exclusao de verdade — o modal so cuida de pedir a senha e mostrar o erro do
// servidor (senha errada, nao configurada, ou a exclusao em si foi barrada por outro motivo).
export default function SenhaMasterModal({ titulo, mensagem, onConfirmar, onCancelar }) {
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState('')
  const [loading, setLoading] = useState(false)

  const confirmar = async () => {
    setErro('')
    setLoading(true)
    try {
      await onConfirmar(senha)
    } catch (err) {
      setErro(err.response?.data?.erro || 'Não foi possível concluir a exclusão.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 380, boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
        <div style={{ fontSize: 20, marginBottom: 8 }}>🔒</div>
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: '#1a1a2e' }}>{titulo}</div>
        <div style={{ fontSize: 13, color: '#666', marginBottom: 16 }}>{mensagem}</div>
        <div className="form-group" style={{ marginBottom: erro ? 8 : 20 }}>
          <label className="form-label">Senha Master</label>
          <input
            className="form-input"
            type="password"
            value={senha}
            onChange={e => setSenha(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && confirmar()}
            autoFocus
          />
        </div>
        {erro && <div className="alert alert-error" style={{ marginBottom: 16, fontSize: 12.5 }}>{erro}</div>}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary" onClick={onCancelar} disabled={loading}>Cancelar</button>
          <button className="btn btn-danger" onClick={confirmar} disabled={loading}>{loading ? 'Excluindo...' : 'Confirmar exclusão'}</button>
        </div>
      </div>
    </div>
  )
}
